import React from 'react';
import {
  Map,
  Devices,
  LocationOn,
  Business,
  QrCode,
  NotificationsActive,
} from '@mui/icons-material';

export const FLEET_TABS = [
  { label: 'Overview', path: '/fleet', icon: <Map /> },
  { label: 'Devices', path: '/fleet/devices', icon: <Devices /> },
  { label: 'Sites', path: '/fleet/sites', icon: <LocationOn /> },
  { label: 'Organizations', path: '/fleet/organizations', icon: <Business /> },
  { label: 'Provisioning', path: '/fleet/provisioning', icon: <QrCode /> },
  { label: 'Alerts', path: '/fleet/alerts', icon: <NotificationsActive /> },
];

export const FLEET_ACCENT_COLOR = '#6366f1';
